// Load Telegram before importing application modules that inspect its launch data.
// A blocked SDK must not leave an empty page or turn a Telegram launch into web login.
function loadTelegram(): Promise<void> {
  if (window.Telegram?.WebApp) return Promise.resolve()
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    const timeout = window.setTimeout(() => finish(false), 12000)
    let settled = false
    function finish(loaded: boolean) {
      if (settled) return
      settled = true
      window.clearTimeout(timeout)
      script.onload = script.onerror = null
      if (loaded && window.Telegram?.WebApp) resolve()
      else reject(new Error('Telegram SDK unavailable'))
    }
    script.src = 'https://telegram.org/js/telegram-web-app.js'
    script.async = true
    script.onload = () => finish(true)
    script.onerror = () => finish(false)
    document.head.appendChild(script)
  })
}

async function start() {
  // Use the actual browser hostname: the regional proxy can rewrite Host and
  // make server redirects loop. Redirect before downloading the large app bundle.
  if (window.location.hostname === 'app.prosora.ru') {
    window.location.replace('https://prosora.ru' + window.location.pathname + window.location.search + window.location.hash)
    return
  }
  try {
    await loadTelegram()
  } catch {
    // Browser visitors do not need Telegram. Detect launch metadata without logging it.
    const launch = window.location.hash + window.location.search
    let storedLaunch = false
    try {
      const params = JSON.parse(sessionStorage.getItem('__telegram__initParams') || '{}')
      storedLaunch = !!(params?.tgWebAppData || params?.tgWebAppPlatform || params?.tgWebAppVersion)
    } catch { /* storage can be disabled or contain invalid JSON */ }
    if (/tgWebApp(Data|Platform|Version)=/.test(launch) || storedLaunch) {
      document.getElementById('startup-help')?.removeAttribute('hidden')
      return
    }
  }
  try {
    await import('./main')
  } catch {
    document.getElementById('startup-help')?.removeAttribute('hidden')
  }
}

void start()
